export class ProvisioningParameter {
  userId: string;
  businessId: string;
  validationCode: string;
  email: string;
  cellphone: string;
  redirectUrl: string;
  allowAutomaticRecharge: boolean;
  salesChannel: string;
  platformAccess: string;
  accountExists: boolean;

  constructor(provisioningParametersData?: any) {
    if (provisioningParametersData) {
      this.userId = provisioningParametersData.userId;
      this.businessId = provisioningParametersData.businessId;
      this.validationCode = provisioningParametersData.validationCode;
      this.email = provisioningParametersData.buyerEmail;
      this.cellphone = provisioningParametersData.buyerPhone;
      this.redirectUrl = provisioningParametersData.redirectUrl;
      this.allowAutomaticRecharge = provisioningParametersData.allowAutomaticRecharge;
      this.salesChannel = provisioningParametersData.salesChannel;
      this.platformAccess = provisioningParametersData.platformAccess;
      this.accountExists = provisioningParametersData.accountExists;
    }
  }
}
